// extracted by mini-css-extract-plugin
module.exports = {"container":"modal-preview-component-container__2ovox","text":"modal-preview-component-text__RjWyJ","button":"modal-preview-component-button__2essq"};